import { gatewayClient } from '../utils/gatewayClient';

export interface FetchDependentsResponse {
  dependents: Array<{
    dependent_id: string;
    dependent_status: string;
    employee_full_name: string;
    first_name: string;
    last_name: string;
    middle_initial: string;
    relationship: string;
  }>;
}

export function fetchDependents({ statuses }: { statuses: string }) {
  return gatewayClient.get<FetchDependentsResponse>('/cdh/v2/dependents', {
    params: {
      statuses,
    },
  });
}

export function addNewDependent({
  first_name,
  last_name,
  phone,
  address,
  shipping_address,
}: $TSFixMe) {
  return gatewayClient.post('/cdh/v2/dependents', {
    first_name,
    last_name,
    address,
    shipping_address,
    phone,
  });
}

export function updateDependent(
  dependent_id: $TSFixMe,
  { first_name, last_name, address, phone, shipping_address, status }: $TSFixMe
) {
  return gatewayClient.put(`/cdh/v2/dependents/${dependent_id}`, {
    first_name,
    last_name,
    phone,
    address,
    shipping_address,
    status,
  });
}

export function fetchDependentDetails(dependent_id: $TSFixMe) {
  return gatewayClient.get(`/cdh/v2/dependents/${dependent_id}`);
}
